import { BaseReducer } from '@hobs/utils/baseReducer';
import { CORDATA, CLEAR } from '@hobs/constants/cor';

class Cor extends BaseReducer {
  static defaultState = {
    cor: {}
  };

  constructor() {
    super(Cor.defaultState);
    this.actionMap = {
      [CORDATA.SUCCESS]: this.loadCorData,
      [CLEAR.SUCCESS]: this.clearCorData
    };
  }

  loadCorData = (state, action) => {
    return Object.assign({}, state, {
      cor: action.payload
    });
  };

  clearCorData = state => {
    return Object.assign({}, state, {
      cor: {}
    });
  };
}

export default new Cor().reducer;
